// AddCategory.js

import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import UserClasses from '../users/Users.module.css';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CategoryClasses from './AddCategory.module.css';
import { Services } from 'Services';
import { useNavigate } from 'react-router-dom';
import { Success, Error } from 'Util/Toast';
import { Button } from '@mui/material';
import CommonCategoryClasses from '../commoncssfiles/CategoryCommon.module.css';
import CommonTutorClasses from '../commoncssfiles/CategoryTutor.module.css';
import { BsCloudUpload } from 'react-icons/bs';
import ReactLoading from 'react-loading';
import ProductClasses from '../products/Products.module.css';

const AddCategory = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [imagePreview, setImagePreview] = useState('');
    const [loading, setLoading] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = ["image/png", "image/jpeg", "image/webp"];
        if (!allowedTypes.includes(file.type)) {
            Error(`${file.name} is not a valid image format.`);
            return;
        }

        let formData = new FormData();
        formData.append("image", file);
        formData.append("folder", "categories");

        try {
            setLoading(true);
            const res = await Services.UploadImage(formData);
            if (res?.Status === 1) {
                const uploadedUrl = res?.ImageURL;
                setUploadedFileName(res?.ImageID);
                setImagePreview(uploadedUrl || URL.createObjectURL(file));
                setValue('imageUrl', res?.ImageID);
                setLoading(false);
            } else {
                Error(res?.Message || "Upload failed.");
                setLoading(false);
            }
        } catch (err) {
            console.error("Upload Error:", err);
            Error("Upload error. Please try again.");
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        console.log('Form submitted with data:', data);
        console.log('Uploaded file name:', uploadedFileName);
        
        if (!uploadedFileName) {
            Error('Please upload an image.');
            return;
        }

        setLoading(true);

        const requestBody = {
            categoryName: data.CategoryName,
            imageUrl: uploadedFileName,
            priority: 1, // Set default priority to 1
        };

        console.log('Request body:', requestBody);

        const token = { Authorization: `token ${localStorage.getItem('Token')}` };

        try {
            const response = await Services.addCategories(requestBody, token);
            console.log('API Response:', response);
            
            if (response.Status === 1) {
                navigate('/categories');
                Success(response.Message);
                console.log('Category added successfully:', response.Message);
            } else {
                Error(response.Message);
                console.error('Error adding category:', response.Message);
            }
        } catch (error) {
            console.error('Error adding category:', error);
            Error('Error adding category');
        } finally {
            setLoading(false);
        }
    };

    const fileuploadDesign = (
        <div className={CommonTutorClasses["add-item"]} onClick={() => document.getElementById("image").click()}>
            <div className={CommonTutorClasses['upload-image']}>
                {imagePreview && <img src={imagePreview} alt="Selected" className={CommonTutorClasses['uploaded-coupon-image']} />}
                {loading && <ReactLoading className={ProductClasses['loading-spinner-container']} type="spin" color="#000" height={50} width={50} />}
                {!imagePreview && (
                    <div className={CommonTutorClasses['add-item']}>
                        <BsCloudUpload className={CommonTutorClasses['upload-icon']} />
                        <h5>Drag Your Files here</h5>
                        <p>(Only *.jpeg, *.png, *.webp will be accepted)</p>
                    </div>
                )}
                <input type="file" id="image" onChange={handleImageUpload} style={{ display: 'none' }} />
            </div>
        </div>
    );

    return (
        <Layout Active={'Categories'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Category</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['add-users-btn']}>
                        <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                            BACK
                        </Button>
                    </div>
                    <div className={CommonTutorClasses['wrapper']} data-aos="zoom-in-down">
                        <h2 className={CommonTutorClasses['main-header']}>Create Category</h2>
                        <form style={{display: 'block'}} className={CommonTutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                            <div style={{marginBottom: '10px'}} className={CommonTutorClasses['form-control']}>
                                <label htmlFor="CategoryName">Category Name</label>
                                <input 
                                    style={{width: '97%'}} 
                                    type='text' 
                                    id="CategoryName"
                                    {...register('CategoryName', { required: 'Category name is required' })} 
                                />
                                {errors.CategoryName && <p className={CategoryClasses["error-text"]}>{errors.CategoryName.message}</p>}
                            </div>
                            <div className={CommonTutorClasses['file-upload-wrapper']}>
                                <header>
                                    <h3>
                                        Upload Category Image <span className="important">*</span>
                                    </h3>
                                </header>
                                <div className={CommonTutorClasses["upload-image"]}>
                                    {fileuploadDesign}
                                </div>
                                {!uploadedFileName && <p className="error-message">Please upload a category image.</p>}
                            </div>
                            <div className={ProductClasses['form-btn-main']}>
                                <Button 
                                    style={{marginTop: '10px'}} 
                                    type="submit" 
                                    variant="contained"
                                    disabled={loading}
                                    onClick={(e) => {
                                        console.log('Button clicked');
                                        // Let the form handle the submission
                                    }}
                                >
                                    {loading ? 'Adding Category...' : 'Add Category'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddCategory;